<template>
  <div class="space-y-4">
    <article
      v-for="sale in saleCards"
      :key="sale.id"
      class="rounded-[2.4rem] border border-black/10 bg-white p-5 shadow-sm"
    >
      <div class="flex items-start gap-4">
        <div class="h-16 w-16 xl:h-20 xl:w-20 rounded-full overflow-hidden bg-black/5">
          <DoctorImage
            :image="sale.avatar || ''"
            :name="sale.doctorName || ''"
            size="100%"
          />
        </div>
        <div class="flex-1 space-y-1">
          <p
            v-if="sale.typeLabel || sale.modeLabel"
            class="m-0 text-[1rem] font-semibold uppercase tracking-wide text-black/50"
          >
            <span v-if="sale.typeLabel">{{ sale.typeLabel }}</span>
            <span v-if="sale.typeLabel && sale.modeLabel"> - </span>
            <span v-if="sale.modeLabel">{{ sale.modeLabel }}</span>
          </p>
          <p class="m-0 text-[1.5rem] font-semibold text-black">
            {{ sale.doctorName }}
          </p>
          <p v-if="sale.service" class="m-0 text-[1.3rem] text-[color:var(--gray)]">
            {{ sale.service }}
          </p>
          <p v-if="sale.tenant" class="m-0 text-[1.2rem] text-[color:var(--gray)]">
            {{ sale.tenant }}
          </p>
        </div>
        <div class="text-right">
          <p class="m-0 text-[1.3rem] font-semibold text-black">
            {{ sale.pendingLabel }}
          </p>
          <p v-if="sale.depositLabel" class="m-0 text-[1.1rem] text-[color:var(--gray)]">
            {{ $t('Deposit today: {amount}', { amount: sale.depositLabel }) }}
          </p>
          <p v-if="sale.duration" class="m-0 text-[1.1rem] text-[color:var(--gray)]">
            {{ sale.duration }}
          </p>
          <button
            type="button"
            class="mt-2 text-[1.1rem] text-red-600 underline"
            @click="$emit('remove-sale', sale.saleId)"
          >
            {{ $t('Remove') }}
          </button>
        </div>
      </div>
      <div class="mt-3 space-y-1 text-[1.2rem] text-[color:var(--gray)]">
        <p v-if="sale.date" class="m-0">{{ sale.date }}</p>
        <p v-if="sale.duration" class="m-0">{{ sale.duration }}</p>
        <p
          v-for="line in sale.descriptionLines"
          :key="line"
          class="m-0 whitespace-pre-line"
        >
          {{ line }}
        </p>
        <pre
          v-if="sale.raw"
          class="mt-3 max-h-48 overflow-auto rounded-[1.2rem] bg-black/[0.04] p-3 text-[1.1rem] text-black/80"
        >{{ sale.raw }}</pre>
      </div>
    </article>
    <article class="rounded-[2.4rem] border border-black/10 bg-white p-5 shadow-sm">
      <div class="flex items-center justify-between text-[1.3rem] text-black">
        <span>{{ $t('Pending reservations') }}</span>
        <strong>{{ formatValue(totalDue) }}</strong>
      </div>
      <p
        v-if="promoApplied && promoDiscount"
        class="mt-2 text-[1.2rem] text-[color:var(--gray)]"
      >
        {{ $t('Discount applied') }}: -{{ formatValue(promoDiscount) }}
      </p>
    </article>
  </div>
</template>

<script>
import DoctorImage from '@/components/doctor/doctorImage.vue';

export default {
  name: 'CheckoutSummaryDetailed',
  components: {
    DoctorImage,
  },
  props: {
    saleCards: {
      type: Array,
      default: () => [],
    },
    totalDue: {
      type: Number,
      default: 0,
    },
    promoApplied: {
      type: Boolean,
      default: false,
    },
    promoDiscount: {
      type: Number,
      default: 0,
    },
    formatAmount: {
      type: Function,
      default: null,
    },
  },
  emits: ['remove-sale'],
  methods: {
    formatValue(value) {
      if (typeof this.formatAmount === 'function') {
        return this.formatAmount(value);
      }
      return value === undefined || value === null ? '-' : String(value);
    },
  },
};
</script>
